import { Component, OnInit } from '@angular/core';
import { commonService } from '../../service/common.service';
import {Globals } from '../../globals';
import { facultyService } from '../../service/faculty.service';
import { Router,ActivatedRoute,Params } from '@angular/router';
@Component({
  selector: 'app-uprofile',
  templateUrl: './uprofile.component.html',
  styleUrls: ['./uprofile.component.css'],
  providers:[facultyService]
  
})
export class UprofileComponent implements OnInit {
  userData:any;
  path:any;
  faculty:any;
  userId:any;
  constructor(private _faculty:facultyService,private _common:commonService,private global: Globals,public router: Router) { 

    this._common.profile.subscribe((data:any)=>{
      if(typeof data=='object' &&  data!=null){
        this.userData = data;
        this.userId=this.userData.id
      }else{
        this.userData={};
        this.userId=0
      } 
   });
   this.path=this.global.objectStorage+this.global.profileFolder+'/';
  }

  ngOnInit() {
      this.getProfile();
  }

  getProfile(){

    this._faculty.facultyprofile(this.userId).subscribe((data : any)=>{
      if(data.error==0){
        this.faculty=data.results;
      }
      else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
       // this.msg = data.message;
       // this.isError = true;
        this.router.navigate(['/']);
        }
      }
      
    })
  }

  changeProfileImg(changeProfile){
    changeProfile.action=true;
    this._common.setProfileImageChangeBox(changeProfile);
  }
 

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/uprofile/uprofile.component.ts